





import {Component, Mixins} from 'vue-mixin-decorator';
import {Prop} from 'vue-property-decorator';

import {LoraForwarderState, LoraForwarderStateColor} from '@/model/lora/LoraForwarderState';

import StatusDisplayer from '@/components/Utils/StatusDisplayer.vue';

import {BaseComponent} from '@/mixins/BaseComponent';

@Component({
  components: {StatusDisplayer},
})
export default class LoraForwarderRunStatus extends Mixins<BaseComponent>(BaseComponent) {

  @Prop({default: LoraForwarderState.Unknown, type: String})
  private state?: LoraForwarderState;

  private LoraForwarderStateColor = LoraForwarderStateColor;
}

